/**
 * Locale constants, split from the i18n barrel so consumers (Storybook
 * preview, test setup, redux stores) can read them without importing the
 * translation catalogue or moment.
 */
export const DEFAULT_LOCALE = 'en'
export const DEFAULT_FULL_LOCALE = 'en-us'

// prettier-ignore
export const appLocales = [
  'en',
  'de'
]
